<template>
  <g>
    <g class="x-axis" :transform="translateX">
      <path :stroke="lineColor" :d="`M0.5,0.5H${contentDimensions.width}`"></path>
      <g
        v-for="(tick, index) in xTicks"
        :key="index"
        :font-size="fontSize"
        :color="lineColor"
        text-anchor="middle"
        :transform="`translate(${tick.position}, 0)`"
      >
        <line
          class="bar-chart-line"
          :style="intervalStyle"
          :y2="`-${contentDimensions.height}`"
          :x2="0"
        ></line>
        <text
          class="axis-label"
          :fill="textColor"
          :y="padding"
          dy="0.71em"
        >
          {{ tick.label }}
        </text>
      </g>
    </g>
  </g>
</template>

<script>
import { bandScale, timeSeriesScale, linearScale }
  from '../../../../../../../services/dashboard/graphs/scalesService';
import { bandTicks, timeSeriesTicks, linearTicks }
  from '../../../../../../../services/dashboard/graphs/ticksService.js';


export default {
  props: {
    // from ChartWrapper
    data: {
      type: Array,
      required: true,
    },
    defaultChartMax: {
      type: Number,
    },
    defaultInterval: {
      type: Number,
    },
    dimensionKey: {
      type: String,
      required: true,
    },
    contentDimensions: {
      type: Object,
      required: true,
    },
    padding: {
      type: Number,
      default: 0,
    },
    dataWidth: {
      type: Number,
      default: 0,
    },
    fontSize: {
      type: Number,
      default: 12,
    },
    // Custom to X Axis
    scale: {
      type: String,
      default: 'band',
      validator: v => {
        return ['band', 'timeSeries', 'linear'].indexOf(v) > -1;
      },
    },
    customChartMax: {
      type: Number,
    },
    customInterval: {
      type: Number,
    },
    intervalStyle: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '#778699',
    },
    lineColor: {
      type: String,
      default: '#778699',
    },
    isInPercentages: {
      type: Boolean,
      default: false,
    },
    useShortLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartMax() {
      return this.customChartMax || this.defaultChartMax;
    },
    interval() {
      return this.customInterval || this.defaultInterval;
    },
    xScale() {
      const range = { min: 0, max: this.contentDimensions.width };
      const domain = { min: 0, max: this.chartMax };
      const args = [ this.data, this.dimensionKey, range ];

      switch (this.scale) {
        case 'timeSeries':
          return timeSeriesScale(...args);
        case 'linear':
          return linearScale(range, domain);
        case 'band':
        default:
          return bandScale(...args);
      }
    },
    translateX() {
      return `translate(0, ${this.contentDimensions.height})`;
    },
    xTicks() {
      const args = [this.xScale, this.data];

      switch (this.scale) {
        case 'timeSeries':
          return timeSeriesTicks(...args);
        case 'linear':
          return linearTicks(
            this.xScale,
            this.interval,
            this.chartMax,
            this.isInPercentages,
          );
        case 'band':
        default:
          return bandTicks(
            ...args,
            this.dimensionKey,
            this.dataWidth,
            this.useShortLabel,
          );
      }
    },
  },
};
</script>

<style scoped>
.axis-label {
  text-transform: uppercase;
}
</style>
